import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

const Welcome = () => import(/* webpackChunkName: "view-Welcome" */ './views/Welcome.vue')
const Login = () => import(/* webpackChunkName: "component-WelcomeLogin" */ './components/Welcome/Login.vue')
const EmailVerification = () => import(/* webpackChunkName: "component-WelcomeEmailVerification" */ './components/Welcome/EmailVerification.vue')
const Activation = () => import(/* webpackChunkName: "component-WelcomeActivation" */ './components/Welcome/Activation.vue')

const MainLayout = () => import(/* webpackChunkName: "view-MainLayout" */ './views/MainLayout.vue')

const Dashboard = () => import(/* webpackChunkName: "view-Dashboard" */ './views/Dashboard.vue')

const Orders = () => import(/* webpackChunkName: "view-Orders" */ './views/Orders.vue')
const OrderDetail = () => import(/* webpackChunkName: "view-OrderDetail" */ './views/OrderDetail.vue')

const Driver = () => import(/* webpackChunkName: "view-Driver" */ './views/Driver.vue')
const DriverList = () => import(/* webpackChunkName: "component-DriverList" */ './components/Driver/List.vue')
const DriverCreate = () => import(/* webpackChunkName: "component-DriverCreate" */ './components/Driver/Create.vue')

const Transport = () => import(/* webpackChunkName: "view-Transport" */ './views/Transport.vue')
const TransportList = () => import(/* webpackChunkName: "component-TransportList" */ './components/Transport/List.vue')
const TransportCreate = () => import(/* webpackChunkName: "component-TransportCreate" */ './components/Transport/Create.vue')

const UserAdmin = () => import(/* webpackChunkName: "view-UserAdmin" */ './views/UserAdmin.vue')
const UserAdminList = () => import(/* webpackChunkName: "component-UserAdminList" */ './components/UserAdmin/List.vue')
const UserAdminCreate = () => import(/* webpackChunkName: "component-UserAdminCreate" */ './components/UserAdmin/Create.vue')

const Schedule = () => import(/* webpackChunkName: "view-Schedule" */ './views/Schedule.vue')

const ShippingProblem = () => import(/* webpackChunkName: "view-ShippingProblem" */ './views/ShippingProblem.vue')
const ShippingProblemDetail = () => import(/* webpackChunkName: "view-ShippingProblemDetail" */ './views/ShippingProblemDetail.vue')
const DamagedAndMissing = () => import(/* webpackChunkName: "view-DamagedAndMissing" */ './views/DamagedAndMissing.vue')

const Invoice = () => import(/* webpackChunkName: "view-Invoice" */ './views/Invoice.vue')
const Invoicelist = () => import(/* webpackChunkName: "component-InvoiceList" */ './components/Invoice/List.vue')
const InvoiceCreate = () => import(/* webpackChunkName: "component-InvoiceCreate" */ './components/Invoice/Create.vue')

const InvoiceData = () => import(/* webpackChunkName: "view-InvoiceData" */ './views/InvoiceData.vue')
const InvoiceDataForm = () => import(/* webpackChunkName: "component-InvoiceDataForm" */ './components/InvoiceData/Form.vue')

const About = () => import(/* webpackChunkName: "view-About" */ './views/About.vue')
const ContactUs = () => import(/* webpackChunkName: "view-ContactUs" */ './views/ContactUs.vue')

const Report = () => import(/* webpackChunkName: "view-Report" */ './views/Report.vue')
const ReportParameter = () => import(/* webpackChunkName: "component-ReportParameter" */ './components/Report/Parameter.vue')
const ReportList = () => import(/* webpackChunkName: "component-ReportList" */ './components/Report/List.vue')
const ReportAging = () => import(/* webpackChunkName: "component-ReportAging" */ './components/Report/ReportAging/index.vue')
const ReportIncome = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportIncome/index.vue')
const ReportArmadaAndDriver = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportArmadaAndDriver/index.vue')
const ReportAccidentArmada = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportAccidentArmada/index.vue')
const ReportOrderShipper = () => import(/* webpackChunkName: "component-ReportIncome" */ './components/Report/ReportOrderShipper/index.vue')
const ReportBasp = () => import(/* webpackChunkName: "component-ReportBASPListBASP" */ './components/Report/ReportBASP/ListBASP/index.vue')

Vue.use(Router)

const AuthGuard = (to, from, next) => {
  console.log('TCL: AuthGuard -> to, from, next', to, from, next)
  if (store.getters['auth/isLoggedIn']) {
    store.dispatch('user/fetchMyInfo')
      .then(res => {
        console.log("TCL: AuthGuard -> store.getters['user/isAllowed'](to.meta.action)", store.getters['user/isAllowed'](to.meta.action))
        if (to.meta.action && !store.getters['user/isAllowed'](to.meta.action)) throw new Error('not allowed')
        return next()
      })
      .catch(err => {
        if (err.message === 'not allowed') {
          Vue.prototype.$message.error(Vue.prototype.$_strings.messages.errors.noAccess)
          return next('/welcome/login')
        }
      })
      .finally(e => {
      })
  } else {
    next('/welcome/login')
  }
}

const loginPageGuard = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next('/main')
  } else {
    next()
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/main',
      component: MainLayout,
      title: 'Main',
      children: [
        {
          path: '',
          redirect: '/main/dashboard'
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          beforeEnter: AuthGuard,
          component: Dashboard,
          meta: {
            title: 'Dashboard',
            action: 'ORDERS_VIEW',
          }
        },
        {
          path: 'orders',
          redirect: 'orders/waiting'
        },
        {
          path: 'orders/:tab',
          name: 'Orders',
          beforeEnter: AuthGuard,
          component: Orders,
          meta: {
            title: 'Pesanan',
            action: 'ORDERS_VIEW',
          }
        },
        {
          path: 'order-detail/:orderId',
          name: 'Order Detail',
          beforeEnter: AuthGuard,
          component: OrderDetail,
          meta: {
            title: 'Rincian Pesanan',
            action: 'ORDERS_DETAIL_VIEW',
          }
        },
        {
          path: 'shipping-problem',
          name: 'Shipping Problem',
          beforeEnter: AuthGuard,
          component: ShippingProblem,
          meta: {
            title: 'Masalah Pengiriman',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'shipping-problem/:orderId',
          name: 'Shipping Problem Detail',
          beforeEnter: AuthGuard,
          component: ShippingProblemDetail,
          meta: {
            title: 'Detil Masalah Pengiriman',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'damaged-and-missing',
          name: 'Damaged And Missing',
          beforeEnter: AuthGuard,
          component: DamagedAndMissing,
          meta: {
            title: 'Kerusakan Dan Kekurangan',
            action: 'ORDER_REPORTS_VIEW',
          }
        },
        {
          path: 'schedule',
          name: 'Schedule',
          beforeEnter: AuthGuard,
          component: Schedule,
          meta: {
            title: 'Jadwal',
            action: 'SCHEDULE_VIEW',
          }
        },
        {
          path: 'report',
          component: Report,
          children: [
            {
              path: 'list',
              name: 'Report List',
              beforeEnter: AuthGuard,
              component: ReportList,
              meta: {
                title: 'Daftar Laporan',
                action: 'ORDERS_VIEW',
              }
            },
            {
              path: ':id',
              name: 'Report Parameter',
              beforeEnter: AuthGuard,
              component: ReportParameter,
              meta: {
                title: 'Parameter Laporan',
                action: 'ORDERS_VIEW',
              },
            },
            {
              path: '1/list',
              name: 'Report Aging',
              beforeEnter: AuthGuard,
              component: ReportArmadaAndDriver,
              meta: {
                title: 'Laporan Armada dan Driver',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '2/list',
              name: 'Report Aging',
              beforeEnter: AuthGuard,
              component: ReportAccidentArmada,
              meta: {
                title: 'Laporan Masalah Armada Pengiriman',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '3/list',
              name: 'Report Aging',
              beforeEnter: AuthGuard,
              component: ReportOrderShipper,
              meta: {
                title: 'Laporan Pesanan Shipper',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '4/list',
              name: 'Report Basp',
              beforeEnter: AuthGuard,
              component: ReportBasp,
              meta: {
                title: 'Detil Laporan Basp',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '5/list',
              name: 'Report Aging',
              beforeEnter: AuthGuard,
              component: ReportAging,
              meta: {
                title: 'Laporan Aging',
                action: 'ORDERS_VIEW'
              }
            },
            {
              path: '6/list',
              name: 'Report Income',
              beforeEnter: AuthGuard,
              component: ReportIncome,
              meta: {
                title: 'Laporan Estimasi Pendapatan',
                action: 'ORDERS_VIEW'
              }
            },
          ]
        },
        {
          path: 'invoice',
          component: Invoice,
          children: [
            {
              path: '',
              redirect: '/main/invoice/list'
            },
            {
              path: 'list',
              name: 'Invoice List',
              beforeEnter: AuthGuard,
              component: Invoicelist,
              meta: {
                title: 'Invoice List',
                action: 'INVOICE_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Invoice Create',
              beforeEnter: AuthGuard,
              component: InvoiceCreate,
              meta: {
                title: 'Buat Invoice',
                action: 'INVOICE_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Invoice Edit',
              beforeEnter: AuthGuard,
              component: InvoiceCreate,
              meta: {
                title: 'Ubah Invoice',
                action: 'INVOICE_UPDATE',
              }
            },
          ]
        },
        {
          path: 'driver',
          component: Driver,
          children: [
            {
              path: '',
              redirect: '/main/driver/list',
            },
            {
              path: 'list',
              name: 'driver-list',
              beforeEnter: AuthGuard,
              component: DriverList,
              meta: {
                title: 'List Sopir',
                action: 'DRIVERS_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Driver Create',
              beforeEnter: AuthGuard,
              component: DriverCreate,
              meta: {
                title: 'Buat Sopir',
                action: 'DRIVERS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Driver Edit',
              beforeEnter: AuthGuard,
              component: DriverCreate,
              meta: {
                title: 'Ubah Sopir',
                action: 'DRIVERS_EDIT',
              }
            }
          ]
        },
        {
          path: 'transport',
          component: Transport,
          children: [
            {
              path: '',
              redirect: '/main/transport/list',
            },
            {
              path: 'list',
              name: 'transport-list',
              beforeEnter: AuthGuard,
              component: TransportList,
              meta: {
                title: 'List Kendaraan',
                action: 'TRANSPORTS_VIEW',
              }
            },
            {
              path: 'create',
              name: 'Transport Create',
              beforeEnter: AuthGuard,
              component: TransportCreate,
              meta: {
                title: 'Buat Kendaraan',
                action: 'TRANSPORTS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'Transport Edit',
              beforeEnter: AuthGuard,
              component: TransportCreate,
              meta: {
                title: 'Ubah Kendaraan',
                action: 'TRANSPORTS_EDIT',
              }
            }
          ]
        },
        {
          path: 'user-admin',
          component: UserAdmin,
          children: [
            {
              path: '',
              redirect: '/main/user-admin/list',
            },
            {
              path: 'list',
              name: 'User Admin List',
              beforeEnter: AuthGuard,
              component: UserAdminList,
              meta: {
                title: 'List User Admin',
                action: 'USERADMINS_VIEW',
              }
            },
            {
              path: 'create',
              name: 'User Admin Create',
              beforeEnter: AuthGuard,
              component: UserAdminCreate,
              meta: {
                title: 'Buat User Admin',
                action: 'USERADMINS_CREATE',
              }
            },
            {
              path: 'edit/:id',
              name: 'User Admin Edit',
              beforeEnter: AuthGuard,
              component: UserAdminCreate,
              meta: {
                title: 'Ubah User Admin',
                action: 'USERADMINS_EDIT',
              }
            }
          ]
        },
        {
          path: 'invoice-data',
          component: InvoiceData,
          children: [
            {
              path: '',
              redirect: '/main/invoice-data/form',
            },
            {
              path: 'form',
              name: 'Invoice Data Form',
              beforeEnter: AuthGuard,
              component: InvoiceDataForm,
              meta: {
                title: 'Invoice Data Form',
                action: 'INVOICEDATA_VIEW',
              }
            },
          ]
        },
        {
          path: 'about',
          name: 'About',
          beforeEnter: AuthGuard,
          component: About,
          meta: {
            title: 'Tentang Kami',
          }
        },
        {
          path: 'contact-us',
          name: 'contact-us',
          beforeEnter: AuthGuard,
          component: ContactUs,
          meta: {
            title: 'Hubungi Kami',
          }
        },
      ]
    },
    {
      path: '/welcome',
      component: Welcome,
      beforeEnter: loginPageGuard,
      children: [
        {
          path: '',
          redirect: '/welcome/login'
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            title: 'Masuk'
          }
        },
        {
          path: 'verification',
          name: 'email-verification',
          component: EmailVerification,
          meta: {
            title: 'Verifikasi Email'
          }
        },
        {
          path: 'activation',
          name: 'activation',
          component: Activation,
          meta: {
            title: 'Aktifasi Akun'
          }
        }
      ]
    },
    {
      path: '*',
      beforeEnter: AuthGuard,
      redirect: '/main'
    }
  ]
})

router.beforeResolve((to, from, next) => {
  document.title = to.meta.title || '3PL Admin Dashboard'
  next()
})

export default router
